module.exports = __webpack_public_path__ + "static/media/comment-alt-exclamation.a081fa26.svg";